<template>
  <div class="type-answer-components">
    <div class="type-answer" :class="genre">
      <div class="text" v-html="message">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FukidashiTitle',
  props: {
    message: String,
    genre: String,
  }
}
</script>
<style scoped lang="scss">
.type-answer {
  margin: 0 auto;
  margin-top: 50px;
  color: #e51c57;
  font-size: 24px;
  line-height: 2em;
  padding: 10px 0;
  background-repeat: no-repeat;
  max-width: 80%;
  width: 100%;
  @media print, screen and (max-width: 730px) {
    font-size: 16px;
    background-position: center;
  }
  &.grocery {
    background-image: url('../../assets/img/job/grocery/back_icon.svg');
  }
  &.nousan {
    background-image: url('../../assets/img/job/nousan/back_icon.svg');
  }
  &.chikusan {
    background-image: url('../../assets/img/job/chikusan/back_icon.svg');
  }
  &.suisan {
    background-image: url('../../assets/img/job/suisan/back_icon.svg');
  }
  &.souzai {
    background-image: url('../../assets/img/job/souzai/back_icon.svg');
  }
  &.nippai {
    background-image: url('../../assets/img/job/nippai/back_icon.svg');
  }
  &.customer {
    background-image: url('../../assets/img/job/customer/back_icon.svg');
  }

}
.text {
  @media print, screen and (min-width: 731px) {
    margin-left: 30%;
    width: 70%;
  }
  @media print, screen and (max-width: 730px) {
    text-align: center;
  }
}
</style>
